import OverviewIndex from './overview.vue';
import FullIndex from './full.vue';
import MobFullIndex from './mob-full.vue';
import MobOverviewIndex from './mob-overview.vue';

export const componentMap = {
	overview: OverviewIndex,
	full: FullIndex,
	'mob-full': MobFullIndex,
	'mob-overview': MobOverviewIndex
};
